import React from 'react';
import ClientInvoiceItemFields, {
    formValueToInvoiceItem,
    newEntryFormValue,
} from '../../../../shared/ClientInvoiceItems/ClientInvoiceItemFields';
import useOrganizationClientRecordInvoiceItems from '../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { Form } from '../../../../v2BaseComponents/Form';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('profiles.editClientBillingInfoScreen.add', {
    create: 'Create',
});

export type AddInvoiceItemContentOwnProps = {
    onCreateInvoiceItem: () => void;
    onCancel: () => void;
    clientRecordId: string;
};

export type AddInvoiceItemContentProps = AddInvoiceItemContentOwnProps;

const AddInvoiceItemContent: React.FC<AddInvoiceItemContentProps> = ({
    clientRecordId,
    onCreateInvoiceItem,
    onCancel,
}) => {
    const { isCreatingInvoiceItem, createInvoiceItem } = useOrganizationClientRecordInvoiceItems({
        clientRecordId,
        onCreateInvoiceItem: onCreateInvoiceItem,
    });

    return (
        <AnimateLoadedContent isLoading={isCreatingInvoiceItem}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={newEntryFormValue}
                    onSubmit={(values) => {
                        const invoiceItem = formValueToInvoiceItem(values);
                        createInvoiceItem({
                            invoiceItems: [invoiceItem],
                        });
                    }}
                    onCancel={onCancel}
                    saveText={intl('create')}
                    saveIcon="CheckCircle"
                >
                    {({ values }) => <ClientInvoiceItemFields values={values} />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddInvoiceItemContent);
